import { render } from "./NationalCodes.vue?vue&type=template&id=974878c8"
import script from "./NationalCodes.vue?vue&type=script&lang=js"
export * from "./NationalCodes.vue?vue&type=script&lang=js"

import "./NationalCodes.vue?vue&type=style&index=0&id=974878c8&lang=scss"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__